module.exports = __webpack_public_path__ + "img/band.05da9fe0.svg";